import { render, staticRenderFns } from "./request-contacts.vue?vue&type=template&id=67f9d4bd&lang=pug&"
import script from "./request-contacts.vue?vue&type=script&lang=js&"
export * from "./request-contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports